const upsellBundleSelectors = document.querySelector("div.upsell_enabled");

if (upsellBundleSelectors) {
  document.addEventListener("DOMContentLoaded", () => {
    const upsellBundleSelectors = document.querySelector("div.upsell_enabled"),
      productFormATCBtn = document.querySelector(
        "div.upsell_enabled button.add-to-cart.upsell-atc"
      ),
      upsellContainer = document.querySelector(".upsell-popup"),
      upsellTotal = document.querySelector(".upsell-total");
    // console.log("upsellContainer", upsellContainer);
    // console.log("productFormATCBtn", productFormATCBtn);
    // console.log("upsellBundleSelectors", upsellBundleSelectors);
    // console.log(
    //   "upsell Pop container",
    //   document.querySelector(".upsell-popup")
    // );

    const bundleSelectors = document.querySelectorAll(
      '[data-element-type="bundle-selector"]'
    );
    const addToCartFormInput = document.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"]'
    );

    const payFullPriceElements = document.querySelectorAll(
      '[data-element-type="pay-full-price"]'
    );
    const payPartPriceElements = document.querySelectorAll(
      '[data-element-type="pay-part-price"]'
    );
    const checkoutButton = document.querySelector("#checkout-button");

    const updatePrices = (bundle) => {
      const selectedPayPartPriceValue = bundle.querySelector(
        'input[name="payPartPrice"]'
      ).value;
      const selectedPayFullPriceValue = bundle.querySelector(
        'input[name="payFullPrice"]'
      ).value;

      payPartPriceElements.forEach((payPartPriceElement) => {
        payPartPriceElement.textContent = selectedPayPartPriceValue;
      });

      payFullPriceElements.forEach((payFullPriceElement) => {
        payFullPriceElement.textContent = selectedPayFullPriceValue;
      });
    };

    const upsellAddItemToCart = async (event) => {
      updateFormInput();
      console.log("addToCartFormInput", addToCartFormInput);
      event.preventDefault();
      event.stopPropagation();
      console.log(event.target);
      console.log("variantId", addToCartFormInput.value);

      try {
        await fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log("cart cleared");
      } catch (error) {
        console.error("Error clearing cart:", error);
      }

      let formData = {
        items: [
          {
            id: addToCartFormInput.value,
          },
        ],
        sections: "cart-drawer",
      };

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const data = await response.json();
        console.log("cart added", data);
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.getSectionsToRender();
          cartDrawer.renderContents(data);
        } else {
          window.location = window.routes.cart_url;
          return;
        }
      } catch (error) {
        console.error("Error:", error);
      }

      try {
        const response = await fetch("/cart.js", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();
        upsellTotal.textContent = data.total_price / 100;
        console.log("cart data", data);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    bundleSelectors.forEach((bundle, index, array) => {
      let bundleInput = bundle.querySelector('input[type="radio"]');
      // console.log(bundleInput.getAttribute("value"));
      // console.log("productFormATCBtn", productFormATCBtn);
      const inputRadio = bundle.querySelector(
        '[data-element-type="radio-button"]'
      );
      const selectedArrow = bundle.querySelector(
        '[data-element-type="selected-arrow"]'
      );

      const updateFormInput = () => {
        if (bundleInput.checked) {
          const variantId = bundleInput.getAttribute("value");
          const cartDrawer = document.querySelector("cart-drawer");
          if (addToCartFormInput) {
            addToCartFormInput.setAttribute("value", variantId);
          }
          if (checkoutButton) {
            checkoutButton.href = `/cart/${variantId}:1`;
          }
        }
      };

      bundleInput.addEventListener("click", () => {
        updateFormInput();

        const allInputRadios = document.querySelectorAll(
          '[data-element-type="radio-button"]'
        );

        const allSelectedArrows = document.querySelectorAll(
          '[data-element-type="selected-arrow"]'
        );

        allInputRadios.forEach((radio) => {
          radio.classList.add("hidden");
        });

        inputRadio.classList.remove("hidden");

        if (allSelectedArrows) {
          allSelectedArrows.forEach((arrow) => {
            arrow.classList.add("hidden");
          });

          if (selectedArrow) {
            selectedArrow.classList.remove("hidden");
          }
        }

        updatePrices(bundle);
      });

      const upsellAddItemToCart = async (event) => {
        // console.log("addToCartFormInput", addToCartFormInput);
        event.preventDefault();

        updateFormInput();
        // console.log(event.target);
        // console.log("variantId", addToCartFormInput.value);

        try {
          await fetch("/cart/clear.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          });
          // console.log("cart cleared");
        } catch (error) {
          console.error("Error clearing cart:", error);
        }

        let formData = {
          items: [
            {
              id: addToCartFormInput.value,
              quantity: 1,
            },
          ],
          sections: "cart-drawer",
        };

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          });

          const data = await response.json();
          // console.log("cart added", data);
          // console.log("item added id", data.items[0].id);
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            cartDrawer.getSectionsToRender();
            cartDrawer.renderContents(data);
          } else {
            window.location = window.routes.cart_url;
            return;
          }
        } catch (error) {
          console.error("Error:", error);
        }

        try {
          const response = await fetch("/cart.js", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });

          const data = await response.json();
          upsellTotal.textContent = data.total_price / 100;
          // console.log("cart data", data);
        } catch (error) {
          console.error("Error:", error);
        }
      };

      // Check if all elements in the array are present
      if (bundleInput) {
        bundleInput.addEventListener("click", upsellAddItemToCart);
      }

      if (bundleInput.checked) {
        inputRadio.classList.remove("hidden");
        updatePrices(bundle); // Update prices on page load based on the checked bundle
        if (selectedArrow) {
          selectedArrow.classList.remove("hidden");
        }
      } else {
        inputRadio.classList.add("hidden");
        if (selectedArrow) {
          selectedArrow.classList.remove("hidden");
        }
      }

      if (index === 0) {
        bundleInput.checked = true;
        // bundleInput.dispatchEvent(new Event("click"));
      }
    });

    //ADD TO CART EVENT LISTENER
    const updateFormInput = () => {
      if (bundleInput.checked) {
        const variantId = bundleInput.getAttribute("value");
        const cartDrawer = document.querySelector("cart-drawer");
        if (addToCartFormInput) {
          addToCartFormInput.setAttribute("value", variantId);
        }
        if (checkoutButton) {
          checkoutButton.href = `/cart/${variantId}:1`;
        }
      }
    };

    // console.log(productFormATCBtn);
    productFormATCBtn.addEventListener("click", async (event) => {
      event.preventDefault();
      // console.log("clicked");
      try {
        await fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });
        // console.log("cart cleared");
      } catch (error) {
        console.error("Error clearing cart:", error);
      }

      let formData = {
        items: [
          {
            id: addToCartFormInput.value,
            // quantity: 1,
          },
        ],
        sections: "cart-drawer",
      };

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const data = await response.json();
        // console.log("cart added", data);
        // console.log("item added id", data.items[0].id);
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.getSectionsToRender();
          cartDrawer.renderContents(data);
        } else {
          window.location = window.routes.cart_url;
          return;
        }
      } catch (error) {
        console.error("Error:", error);
      }

      try {
        const response = await fetch("/cart.js", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();
        upsellTotal.textContent = data.total_price / 100;
        // console.log("cart data", data);
      } catch (error) {
        console.error("Error:", error);
      }
    });
  });
} else {
  document.addEventListener("DOMContentLoaded", () => {
    const bundleSelectors = document.querySelectorAll(
      '[data-element-type="bundle-selector"]'
    );
    const addToCartFormInput = document.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"]'
    );

    const payFullPriceElements = document.querySelectorAll(
      '[data-element-type="pay-full-price"]'
    );
    const payPartPriceElements = document.querySelectorAll(
      '[data-element-type="pay-part-price"]'
    );
    const checkoutButton = document.querySelector("#checkout-button");

    const updatePrices = (bundle) => {
      const selectedPayPartPriceValue = bundle.querySelector(
        'input[name="payPartPrice"]'
      ).value;
      const selectedPayFullPriceValue = bundle.querySelector(
        'input[name="payFullPrice"]'
      ).value;

      payPartPriceElements.forEach((payPartPriceElement) => {
        payPartPriceElement.textContent = selectedPayPartPriceValue;
      });

      payFullPriceElements.forEach((payFullPriceElement) => {
        payFullPriceElement.textContent = selectedPayFullPriceValue;
      });
    };

    bundleSelectors.forEach((bundle, index, array) => {
      const bundleInput = bundle.querySelector('input[type="radio"]');
      const inputRadio = bundle.querySelector(
        '[data-element-type="radio-button"]'
      );
      const selectedArrow = bundle.querySelector(
        '[data-element-type="selected-arrow"]'
      );

      const updateFormInput = () => {
        if (bundleInput.checked) {
          const variantId = bundleInput.getAttribute("value");
          if (addToCartFormInput) {
            const formType = addToCartFormInput.getAttribute('form-type');
            if (formType !== 'cart-upsell') {
              addToCartFormInput.setAttribute("value", variantId);
            }
          }
          if (checkoutButton) {
            checkoutButton.href = `/cart/${variantId}:1`;
          }
        }
      };

      bundleInput.addEventListener("click", () => {
        updateFormInput();

        const allInputRadios = document.querySelectorAll(
          '[data-element-type="radio-button"]'
        );

        const allSelectedArrows = document.querySelectorAll(
          '[data-element-type="selected-arrow"]'
        );

        allInputRadios.forEach((radio) => {
          radio.classList.add("hidden");
        });

        inputRadio.classList.remove("hidden");

        if (allSelectedArrows) {
          allSelectedArrows.forEach((arrow) => {
            arrow.classList.add("hidden");
          });

          if (selectedArrow) {
            selectedArrow.classList.remove("hidden");
          }
        }

        updatePrices(bundle);
      });

      updateFormInput();

      if (bundleInput.checked) {
        inputRadio.classList.remove("hidden");
        updatePrices(bundle); // Update prices on page load based on the checked bundle
        if (selectedArrow) {
          selectedArrow.classList.remove("hidden");
        }
      } else {
        inputRadio.classList.add("hidden");
        if (selectedArrow) {
          selectedArrow.classList.remove("hidden");
        }
      }

      // If this is the first bundle, automatically check its radio button
      // if (index === 0) {
      //   bundleInput.checked = true;
      //   bundleInput.dispatchEvent(new Event("click"));
      // }
    });
    
    for (const bundleSelector of bundleSelectors) {
      bundleSelector.onclick = function (event) {
        const itemCount = bundleSelector.getAttribute('data-item-count');

        for (const oneElement of bundleSelectors) {
          oneElement.classList.remove('active');
        }
        bundleSelector.classList.add('active');

        const customTitle = bundleSelector.getAttribute('data-variant-title');
        if (customTitle) {
          const customTitleElement = document.querySelector('.product-section-dynamic-title');
          if (customTitleElement) {
            customTitleElement.textContent = customTitle;
          }
        }

        // Update variant image dynamatically
        if (itemCount) {
          const imageToReplace = document.querySelector(`.hidden-variant-advert-image[data-count="${itemCount}"]`);
          const parentElement = document.querySelector('#my-keen-slider .keen-slider__slide:first-child > div');

          if (imageToReplace && parentElement) {
            parentElement.innerHTML = '';
            parentElement.appendChild(imageToReplace.cloneNode(true));
          }
        }
      };
    }
  });
}

// document.addEventListener("DOMContentLoaded", () => {
//   const upsellBundleSelectors = document.querySelector("div.upsell_enabled"),
//     productFormATCBtn = document.querySelector(
//       "div.upsell_enabled button.add-to-cart"
//     ),
//     upsellContainer = document.querySelector(".upsell-popup"),
//     upsellTotal = document.querySelector(".upsell-total");
//   console.log("upsellContainer", upsellContainer);
//   console.log("productFormATCBtn", productFormATCBtn);
//   console.log("upsellBundleSelectors", upsellBundleSelectors);
//   console.log("upsell Pop container", document.querySelector(".upsell-popup"));

//   const bundleSelectors = document.querySelectorAll(
//     '[data-element-type="bundle-selector"]'
//   );
//   const addToCartFormInput = document.querySelector(
//     'form[data-type="add-to-cart-form"] input[name="id"]'
//   );

//   const payFullPriceElements = document.querySelectorAll(
//     '[data-element-type="pay-full-price"]'
//   );
//   const payPartPriceElements = document.querySelectorAll(
//     '[data-element-type="pay-part-price"]'
//   );
//   const checkoutButton = document.querySelector("#checkout-button");

//   let bundleInput;

//   const updatePrices = (bundle) => {
//     const selectedPayPartPriceValue = bundle.querySelector(
//       'input[name="payPartPrice"]'
//     ).value;
//     const selectedPayFullPriceValue = bundle.querySelector(
//       'input[name="payFullPrice"]'
//     ).value;

//     payPartPriceElements.forEach((payPartPriceElement) => {
//       payPartPriceElement.textContent = selectedPayPartPriceValue;
//     });

//     payFullPriceElements.forEach((payFullPriceElement) => {
//       payFullPriceElement.textContent = selectedPayFullPriceValue;
//     });
//   };

//   const updateFormInput = () => {
//     if (bundleInput && bundleInput.checked) {
//       const variantId = bundleInput.getAttribute("value");
//       const cartDrawer = document.querySelector("cart-drawer");
//       if (addToCartFormInput) {
//         addToCartFormInput.setAttribute("value", variantId);
//       }
//       if (checkoutButton) {
//         checkoutButton.href = `/cart/${variantId}:1`;
//       }
//     }
//   };

//   const addToCart = async () => {
//     updateFormInput();
//     console.log("addToCartFormInput", addToCartFormInput);

//     try {
//       await fetch("/cart/clear.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });
//       console.log("cart cleared");
//     } catch (error) {
//       console.error("Error clearing cart:", error);
//     }

//     let formData = {
//       items: [
//         {
//           id: addToCartFormInput.value,
//           quantity: 1,
//         },
//       ],
//       sections: "cart-drawer",
//     };

//     try {
//       const response = await fetch("/cart/add.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });

//       const data = await response.json();
//       console.log("cart added", data);
//       console.log("item added id", data.items[0].id);
//       const cartDrawer = document.querySelector("cart-drawer");
//       if (cartDrawer) {
//         cartDrawer.getSectionsToRender();
//         cartDrawer.renderContents(data);
//       } else {
//         window.location = window.routes.cart_url;
//         return;
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     }

//     try {
//       const response = await fetch("/cart.js", {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });

//       const data = await response.json();
//       upsellTotal.textContent = data.total_price / 100;
//       console.log("cart data", data);
//     } catch (error) {
//       console.error("Error:", error);
//     }
//   };

//   bundleSelectors.forEach((bundle, index) => {
//     bundleInput = bundle.querySelector('input[type="radio"]');
//     const inputRadio = bundle.querySelector(
//       '[data-element-type="radio-button"]'
//     );
//     const selectedArrow = bundle.querySelector(
//       '[data-element-type="selected-arrow"]'
//     );

//     bundleInput.addEventListener("click", () => {
//       updateFormInput();

//       const allInputRadios = document.querySelectorAll(
//         '[data-element-type="radio-button"]'
//       );

//       const allSelectedArrows = document.querySelectorAll(
//         '[data-element-type="selected-arrow"]'
//       );

//       allInputRadios.forEach((radio) => {
//         radio.classList.add("hidden");
//       });

//       inputRadio.classList.remove("hidden");

//       if (allSelectedArrows) {
//         allSelectedArrows.forEach((arrow) => {
//           arrow.classList.add("hidden");
//         });

//         if (selectedArrow) {
//           selectedArrow.classList.remove("hidden");
//         }
//       }

//       updatePrices(bundle);
//       addToCart(); // Call the shared addToCart function
//     });

//     if (bundleInput.checked) {
//       inputRadio.classList.remove("hidden");
//       updatePrices(bundle);
//       if (selectedArrow) {
//         selectedArrow.classList.remove("hidden");
//       }
//     } else {
//       inputRadio.classList.add("hidden");
//       if (selectedArrow) {
//         selectedArrow.classList.remove("hidden");
//       }
//     }

//     if (index === 0) {
//       bundleInput.checked = true;
//     }
//   });

//   // ADD TO CART EVENT LISTENER for productFormATCBtn
//   if (productFormATCBtn) {
//     productFormATCBtn.addEventListener("click", addToCart);
//   }
// });
